import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setTried as updateTried } from "../redux/userSlice";
import { MinorUserContext } from "../context/UserNameProvider";
import Question from "../components/Question";
import { Box, FormControlLabel, FormControl, Checkbox, useTheme, Typography } from "@mui/material";
import ContinueButton from "../components/ContinueButton";
import { checkboxSx, continueButtonSx } from "../lib/uiformatting";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function Tried() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isMinor, firstName } = useContext(MinorUserContext);
    const theme = useTheme();

    const user = useSelector((state) => state.user);

    const tryText = {
        "Tried prescription(s)": "Tried prescription(s)",
        "Tried something else (over-the-counter drug, diet changes, other)":
            "Tried something else (over-the-counter drug, diet changes, other)",
        "I haven't tried anything": "I haven't tried anything",
    };

    const [tried, setTried] = useState([]);

    useEffect(() => {
        const triedArray = Array.isArray(user.tried) ? user.tried : [];
        setTried(triedArray);
    }, [user.tried]);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        let updatedTried;

        if (name === "I haven't tried anything") {
            updatedTried = checked ? [name] : [];
        } else {
            updatedTried = checked
                ? tried.filter((item) => item !== "I haven't tried anything").concat(name)
                : tried.filter((item) => item !== name);
        }
        setTried(updatedTried);
    };

    const handleNext = () => {
        dispatch(updateTried(tried));
        if (tried.includes("Tried prescription(s)")) {
            setPageAndDeferNavigate(dispatch, '/prescriptions', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/duration', navigate);
        }
    };

    const handleBack = () => {
        if (isMinor) {
            setPageAndDeferNavigate(dispatch, '/minor/instructions', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/whats-next', navigate);
        }
    };

    return (
        <Question
            onBack={handleBack}
            title={`What ${isMinor ? `has ${firstName}` : "have you"} tried so far?`}
            subtitle="Choose all that apply"
            input={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: "400px",
                            [theme.breakpoints.up("sm")]: {
                                margin: "0 auto",
                            },
                        }}
                    >
                        <FormControl
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                                mb: "2rem",
                            }}
                        >
                            {Object.keys(tryText).map((key) => {
                                let labelContent = tryText[key];
                                if (
                                    key ===
                                    "Tried something else (over-the-counter drug, diet changes, other)"
                                ) {
                                    labelContent = (
                                        <>
                                            Tried something else{" "}
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{
                                                    fontSize: "0.8em",
                                                    color: "grayTones.main",
                                                    fontStyle: "italic",
                                                }}
                                            >
                                                (over-the-counter drug, diet changes, other)
                                            </Typography>
                                        </>
                                    );
                                }

                                return (
                                    <FormControlLabel
                                        key={key}
                                        control={
                                            <Checkbox
                                                checked={tried.includes(key)}
                                                onChange={handleCheckboxChange}
                                                name={key}
                                            />
                                        }
                                        label={labelContent}
                                        sx={{ ...checkboxSx }}
                                    />
                                );
                            })}
                        </FormControl>
                    </Box>
                </Box>
            }
            footer={
                <Box
                    sx={{
                        ...continueButtonSx,
                        position: "sticky",
                        bottom: 0,
                        zIndex: 9999,
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <ContinueButton
                        onClick={handleNext}
                        title="Continue"
                        selected={tried.length > 0}
                        disabled={tried.length === 0}
                    />
                </Box>
            }
        />
    );
}
